import { type Branded, brand } from '../Branded';
import { NonEmptyStringError } from './non-empty-string-error';

export type NonEmptyString = Branded<string, 'nonEmptyString'>;

export function asNonEmptyString(value: string): NonEmptyString {
  if (!isNonEmptyString(value)) {
    throw new NonEmptyStringError(value);
  }
  return brand<NonEmptyString>(value);
}

export function isNonEmptyString(value: string): value is NonEmptyString {
  return value.length > 0;
}
